const PREFIX = "Metadata";
export const SET_SELECTED_SECTION = `${PREFIX}_SET_SELECTED_SECTION`;
